import { render, staticRenderFns } from "./DialogDisclaimer.vue?vue&type=template&id=a5ac1e28&"
import script from "./DialogDisclaimer.vue?vue&type=script&lang=js&"
export * from "./DialogDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports